import React from "react";
import { bool, array } from "prop-types";
import { Box, Stack, Paper, Typography } from "@mui/material";
import ProgressIndicator from "../ProgressIndicator";
import AppPage from ".";

import { connectToState } from "../../redux/connect-api";
import CurrentVideo from "../CurrentVideo";
import VideoGrid from "../VideoGrid";
import LandingTitle from "../landing/LandingTitle";
import AppPageContentWrapper from "./AppPageContentWrapper";
import useUserHasAccess from "../../hooks/useUserHasAccess";
import AccessFlag from "../AccessFlag";

export const Webinars = ({ mediaResources, loading }) => {
  const userHasAccess = useUserHasAccess();
  const webinars = mediaResources.filter((r) => r.resource_type === "webinar");

  if (loading) {
    return (
      <Paper id="" elevation={0}>
        <ProgressIndicator active={loading} />
      </Paper>
    );
  }

  if (!userHasAccess) {
    return <AccessFlag toolName="Webinars" />;
  }

  if (!webinars.length) {
    return (
      <AppPage title="Webinars">
        <Box
          component="section"
          sx={{
            alignContent: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            my: 4,
          }}
        >
          <Typography variant="h3" component="h2" align="center" style={{ marginBottom: 10 }}>
            We&apos;ll be posting the first webinar soon.
          </Typography>
          <Typography align="center">
            Check out our{" "}
            <a
              href="https://www.youtube.com/channel/UCEIQ-x96XBnHGcrfJ-oMBgQ/videos"
              target="_blank"
              rel="noreferrer"
            >
              Youtube channel
            </a>{" "}
            in the meantime.
          </Typography>
        </Box>
      </AppPage>
    );
  }

  const currentWebinar = webinars[0];
  let archivedWebinars = [...webinars];
  archivedWebinars.shift();

  // TODO: Remove Header component?
  return (
    <AppPage title="Webinars">
      <AppPageContentWrapper>
        <Stack
          direction="column"
          sx={{
            gap: 0,
          }}
        >
          <Box sx={{ marginBottom: "50px" }}>
            {currentWebinar && (
              <Box sx={{ mb: 4 }}>
                <CurrentVideo video={currentWebinar} borderRadius={4} hasLeftBorder={true} />
              </Box>
            )}
          </Box>
          {archivedWebinars.length > 0 && (
            <Box sx={{ marginBottom: "60px" }}>
              <VideoGrid
                Header={() => (
                  <Box sx={{ mb: 4 }}>
                    <LandingTitle>Archive:</LandingTitle>
                  </Box>
                )}
                videos={archivedWebinars}
              />
            </Box>
          )}
        </Stack>
      </AppPageContentWrapper>
    </AppPage>
  );
};

Webinars.defaultProps = {
  loading: true,
  mediaResources: [],
};

Webinars.propTypes = {
  loading: bool,
  mediaResources: array,
};

const mapStateToProps = (state) => {
  return {
    loading: state.userProfile.loading || state.mediaResources.loading,
    mediaResources: state.mediaResources.data,
  };
};

export default connectToState(mapStateToProps)(Webinars);
